module.exports = __webpack_public_path__ + "img/ana-patricia.aa23e76f.png";